import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";

export const emptyDataModelRequest: ServerSideDataModelRequest = {
	paginationModel: null,
	sortModel: [],
};
